const ua = () => {
    let ua = navigator.userAgent;
    ua.toLowerCase();

    if (/android/i.test(ua)) {
        document.body.setAttribute("data-android", 1);
    }
    if (/windows/i.test(ua)) {
        document.body.setAttribute("data-windows", 1);
    }

    if (/chrome/i.test(ua)) {
        document.body.setAttribute("data-chrome", 1);
    }
};

export { ua };
